module.exports = __webpack_public_path__ + "static/media/client-feedback.ae3c0996.png";